import React, {useState, useContext, useEffect, useCallback, useMemo} from "react";
import {
    TokenContext, TreeContext
} from "../../Store";
import {makeStyles} from "@mui/styles";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ComponentTypeAutoComplete from "../../../shared/ComponentTypeAutoComplete";
import {trackPromise} from "react-promise-tracker";
import DataComponentService from "../../../services/DataComponentService";
import ListComponenttype from "./ListComponenttype";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import ListSelectedComponenttypeBox from "./ListSelectedComponenttypeBox";
import RenderOnRole from "../../RenderOnRole";


const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    paper: {
        width: 400,
        height: 300,
        overflow: 'auto',
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
}));

function BimProfilesComponents({setComponenttypes, setAttributes, attributes, componenttypes, theRealm}) {
    const classes = useStyles();

    const [token] = useContext(TokenContext);
    const tree = useContext(TreeContext);
    const treeItemsState = tree.items;

    const [value, setValue] = React.useState(null);
    const [, setExpanded] = React.useState([]);
    const [myComponentType, setMyComponentType] = useState([]);
    const [selectedComponenttypes, setSelectedComponenttypes] = useState([]);
    const [checkedAttributes, setCheckedAttributes] = useState([]);
    const [selectedAttributes, setSelectedAttributes] = useState([]);
    const [counter, setCounter] = useState(0);
    const [currentObjectTypeId, setCurrentObjectTypeId] = useState(null);
    const [currentObjectType, setCurrentObjectType] = useState(null);
    const [showAttributes, setShowAttributes] = useState(false);

    useEffect(() => {
        setSelectedComponenttypes(componenttypes);
        setSelectedAttributes(attributes);
    }, [componenttypes, attributes]);

    const treeFlatList = useMemo(() => {
        const list = [];
        function convert(item) {
            list.push({
                name: item.name,
                id: item.objecttype_id,
                code: item.code,
                title: item.code + ' - ' + item.name,
                cafmId: item.cafm_id,
                globalId: item.global_id,
                key: item.global_id,
            });
            item.children_objecttypes?.forEach(child => convert(child));
        }
        treeItemsState.forEach(item => convert(item));
        return list;
    }, [treeItemsState]);

    const setComponentTypeValue = async (val) => {
        setValue(val);
        if (val) {
            try {
                const result = await trackPromise(
                    DataComponentService.getComponentTypeByCode(token, theRealm, val.code)
                );
                setMyComponentType(result.data);
                setCheckedAttributes([]);
            } catch (e) {
                console.error("Fehler beim Laden des Bauteiltyps:", e);
            }
        } else {
            setExpanded([]);
        }
    };

    const setComponentAndAttributes = useCallback(() => {
        if (currentObjectType?.objecttype_id === currentObjectTypeId) {
            const newComponents = selectedComponenttypes.includes(currentObjectType)
                ? selectedComponenttypes
                : [...selectedComponenttypes, currentObjectType];

            const newAttributes = [...selectedAttributes];
            currentObjectType.attribute?.forEach((attr) => {
                if (!newAttributes.includes(attr)) {
                    newAttributes.push(attr);
                }
            });

            setSelectedComponenttypes(newComponents);
            setSelectedAttributes(newAttributes);
            setComponenttypes(newComponents);
            setAttributes(newAttributes);
        }
        setCounter(c => c + 1);
    }, [currentObjectType, currentObjectTypeId, selectedComponenttypes, selectedAttributes, setAttributes, setComponenttypes]);

    const deleteComponenttype = (id) => {
        const arr = selectedComponenttypes.filter(attr => attr.objecttype_id !== id);
        setSelectedComponenttypes(arr);
        setComponenttypes(arr);
        setCounter(c => c + 1);
    };

    const deleteAttribute = (id) => {
        const arr = selectedAttributes.filter(attr => attr.attribute_id !== id);
        setSelectedAttributes(arr);
        setAttributes(arr);
        setCounter(c => c + 1);
    };

    return (
        <>
            <List style={{backgroundColor: "#FFFFFF"}}>
                <ListItem>
                    <ComponentTypeAutoComplete
                        flatList={treeFlatList}
                        setValue={setComponentTypeValue}
                        value={value}
                        label="Bauteiltypen wählen oder Text eingeben"
                    />
                </ListItem>
                <Grid container spacing={2} justifyContent="center" alignItems="center" className={classes.root}>
                    <Grid item>
                        <Paper className={classes.paper}>
                            <ListComponenttype
                                items={myComponentType}
                                currentObjectTypeId={currentObjectTypeId}
                                setCurrentObjectTypeId={setCurrentObjectTypeId}
                                showAttributes={showAttributes}
                                setShowAttributes={setShowAttributes}
                                setCurrentObjectType={setCurrentObjectType}
                                checkedAttributes={checkedAttributes}
                                setCheckedAttributes={setCheckedAttributes}
                                theRealm={theRealm}
                            />
                        </Paper>
                    </Grid>
                    <RenderOnRole roles={['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN']}>
                        <Button
                            onClick={setComponentAndAttributes}
                            startIcon={<SaveIcon />}
                            color="primary"
                            variant="outlined"
                            style={{"marginLeft": "5px"}}
                        >&gt;&gt;</Button>
                    </RenderOnRole>
                    <Grid item>
                        <ListSelectedComponenttypeBox
                            selectedComponenttypes={selectedComponenttypes}
                            setSelectedComponenttypes={setSelectedComponenttypes}
                            selectedAttributes={selectedAttributes}
                            setSelectedAttributes={setSelectedAttributes}
                            counter={counter}
                            deleteAttribute={deleteAttribute}
                            deleteComponenttype={deleteComponenttype}
                            theRealm={theRealm}
                        />
                    </Grid>
                </Grid>
            </List>
        </>
    );
}

export default BimProfilesComponents;
